import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { memo, useMemo } from 'react';
import strings from '../../Globalization/index';
import consts from '../../consts';
import { useCycleInfo } from '../../contexts/CycleInfo/Context';
import util from '../../util/index';
import { ProcessMonitoringStatus } from '../ProcessMonitoringStatus';

const StyledTableRow = styled(TableRow)(({ theme }) => ({
	'&:nth-of-type(odd)': {
		backgroundColor: theme.palette.action.hover
	},
	// hide last border
	'&:last-child td, &:last-child th': {
		border: 0
	}
}));
const FlowCheckTable = () => {
	const { isWasher, isUltraSonic, data } = useCycleInfo();
	const flowCheckTable = data.FlowCheckTable;

	const columns = useMemo(() => {
		const tableColumns = [];
		const isEnspire = data?.EquipmentFamilyId === consts.EquipmentFamilyType.ENSPIRE;
		const title = isEnspire ? strings.ChannelMonitor : strings.FlowCheckTittle;

		if (
			util.checkAccess('LeakTestAccess') &&
			data?.LeakTestTopFlow?.Value !== consts.DefaultValues.IntegerNull &&
			data?.LeakTestBottomFlow?.Value !== consts.DefaultValues.IntegerNull
		) {
			if (!isWasher || !isUltraSonic) {
				for (let bottomFlowId = 0; bottomFlowId <= consts.BottomFlow.Last; bottomFlowId++) {
					tableColumns.push(bottomFlowId === 0 ? title : bottomFlowId);
				}
			}
		}
		return tableColumns;
	}, [data, isWasher, isUltraSonic]);


	return (
		<TableContainer component={Box}>
			{columns.length > 0 && flowCheckTable.length > 1 && (
				<Table aria-label="flow check table" size="small">
					<TableHead>
						<TableRow>
							{columns.map((column, index) => (
								<TableCell key={`flowCheckTableColumn-${index}`}>{column}</TableCell>
							))}
						</TableRow>
					</TableHead>
					<TableBody>
						{flowCheckTable.map((cells, rowIndex) => (
							<StyledTableRow key={`row-${rowIndex}`}>
								{cells.map(({ value, isPass, color }, cellIndex) => (
									<TableCell key={`row-${rowIndex}-cell-${`${cellIndex}`}`}>
										{value}
										<ProcessMonitoringStatus CriticalParameterIcon={isPass} align={'start'} ml={-1} sx={{ color }} />
									</TableCell>
								))}
							</StyledTableRow>
						))}
					</TableBody>
				</Table>
			)}
		</TableContainer>
	);
}
export default memo(FlowCheckTable);
